export const ORGANIZATIONS_API = '/api/john-deere/organizations';
